import { useEffect, useRef } from "react";
import { lerp } from "@ui/lib/linear_interpolation";

export function useScrollAnimation(root: React.RefObject<HTMLElement>, enabled = true) {
  const frame = useRef<number>();
  const p = useRef(0);
  useEffect(() => {
    if (!enabled) return;
    if (!root.current) return;
    function loop() {
      const y = window.scrollY;
      const p2 = Math.max(0, Math.min(y / 32, 1));
      p.current = Number(lerp(p.current, p2, 0.5).toFixed(2));
      root.current?.style.setProperty("--sticky-header-animation-progress", `${p.current}`);
      frame.current = window.requestAnimationFrame(loop);
    }
    frame.current = window.requestAnimationFrame(loop);
    return () => (frame.current ? cancelAnimationFrame(frame.current) : undefined);
  }, [enabled, root]);
}
